import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { DeleteIconComponent } from '@itero/ui-toolkit-angular/icons';

@Component({
	selector: 'rx-intuitive-remove-from-bridge-button',
	templateUrl: './rx-intuitive-remove-from-bridge-button.component.html',
	styleUrls: ['./rx-intuitive-remove-from-bridge-button.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslateModule, TlkButtonComponent, DeleteIconComponent]
})
export class RxIntuitiveRemoveFromBridgeButtonComponent {
	@Input() disabled = false;

	@Output() buttonClick = new EventEmitter<void>();

	onClicked(): void {
		if (!this.disabled) {
			this.buttonClick.emit();
		}
	}
}
